import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

export const subHeaderStyles = {
  subHeaderStylesFontOnWhite: {
    fontFamily: "'Noto Sans HK', sans-serif",
    fontSize: 16,
    fontWeight: 500,
    color: '#484848',
    lineHeight: '26px',
    margin: 0,
    padding: 0,
  },
  subHeaderStylesFontOnGreen: {
    fontFamily: "'Noto Sans HK', sans-serif",
    fontSize: 16,
    fontWeight: 400,
    color: '#484848',
    lineHeight: '26px',
    margin: 0,
    padding: 0,
  },
};

const useStyles = makeStyles(() => subHeaderStyles);

const SubHeader = (props) => {
  const { className, onGreen, ...otherProps } = props;
  const classes = useStyles();

  return (
    <Typography
      className={classNames([
        onGreen ? classes.subHeaderStylesFontOnGreen : classes.subHeaderStylesFontOnWhite,
        className,
      ])}
      component="h3"
      {...otherProps}>
      {props.children}
    </Typography>
  );
};

SubHeader.propTypes = {
  onGreen: PropTypes.bool,
};

export default SubHeader;
